// マテリアルアイコン付きボタン
<template>
  <!-- <div> -->
  <b-button @click="onClick" class="cx_button" ref="tooltip_target" @mousedown="onMouseDown" @mouseup="onMouseUp" :disabled="isDisabled">
    <div v-if="!$scopedSlots.default">
      <i v-if="icon != null && icon != ''" class="material-icons small valign">{{icon}}</i>{{titleSC}}
    </div>
    <slot></slot>
  </b-button>
      <!-- <b-tooltip target="tooltip-button-1"> Hello World!</b-tooltip>
    </div> -->
</template>
<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
  @Prop() public caption: string;
  @Prop() public icon: string;
  @Prop({default:null}) public sc: string;
  @Prop({default:null}) public tooltip: string;
  @Prop({default:false}) public disabled: boolean;
  @Prop({default:null}) public perm: string;
 @Prop({default:'right'}) public placement: string;

  public get isDisabled() {
    return this.disabled || !this.$api.perms.hasMenuPermission(this.perm);
  }
  public get titleSC(){
    if (this.sc==null) return this.$translate(this.caption);
    else return this.$translate(this.caption) +'('+ this.sc +')';
  }
 //#region　フォーカス制御～Read以外の場合に確認ダイアログを表示する
  public created() {
    // if (this.sc != null) document.body.addEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.add(this.sc, this.onClick);    
  }
  public mounted() {
    if(this.tooltip) this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip,this.placement);
  }

  public destroyed() {
    // if (this.sc != null) document.body.removeEventListener('keydown', this.onKeyDown);
    if (this.sc != null) this.$api.sckeys.remove(this.sc, this.onClick);    
  }

  // public onKeyDown(ev: KeyboardEvent){
  //   if (ev.key == this.sc){
  //     ev.preventDefault();
  //     this.OnClick();
  //   }
  // }

  public onClick(): boolean {
    //GA4イベント(エディタの業務処理ボタンもしくは明細グリッドの業務処理ボタン)
    if (this.$el.parentElement && this.$el.parentElement.classList.contains('cx_appevent_enabled')) this.$api.issueGA4event(this.$route.path,this.caption);    
    // if (this.$api.perms.hasMenuPermission(this.perm) && this.enabled) {
    //   this.$emit('click');
    // }
    this.$root.$emit('bv::hide::tooltip');
    this.$emit('click');    
    return true;
  }

  // @Emit('click')
  // public OnClick() { }

  @Emit('mousedown')
  public onMouseDown(){}
  @Emit('mouseup')
  public onMouseUp(){}  
}
</script>
<style lang="scss">
.cx_button {

  color: #444;
  border: 1px solid #ccc;
  border-radius: 5px;
  // padding: 4px 20px;
  font-weight: 400;
  background: linear-gradient(to bottom, #f9f9f9 0, #e0e0e0 100%);
  text-shadow: 0 1px 0 rgba(255, 255, 255, 1), 0 0 0 rgba(255, 255, 255, 0);
  box-shadow: none;
  white-space: nowrap;
  i{
    margin-right:5px;
  }
  &:hover:not(:disabled){
    color: #444;
    border: 1px solid #bbb;
    background: linear-gradient(to bottom, #f6f6f6 0, #d4d4d4 100%);
  }
  &:active:not(:disabled){
    color: #444 !important;
    border: 1px solid #999 !important;
    background: linear-gradient(to bottom, #ececec 0, #c9c9c9 100%);
    box-shadow: none !important;
  }  
  &:focus{
    box-shadow: none !important;
  }
  &:disabled{
    border: 1px solid #cecece;
    color: #999898;
    background: linear-gradient(to bottom, #f9f9f9 0, #eeeeee 100%);    
    opacity:unset !important; //スタッキングコンテクストを解除し非活性カラーを定義
  }
}
</style>